<template><div><h1 id="kostentrager" tabindex="-1"><a class="header-anchor" href="#kostentrager"><span>Kostenträger</span></a></h1>
<p>Kostenträger — Definiert Kostenträger</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Tabelle Kostenträger dient der Überprüfung der Dateneingabe und Fakturierung, indem hier sämtliche gültigen Kostenträger eingegeben werden müssen. Das System überwacht dann automatisch die Buchungen für die Schnittstelle Finanzbuchhaltung, indem es das Vorhandensein des Kostenträgers überprüft und validiert.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Kontenplan</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Kostenträger</dt>
<dd>Kostenträger</dd>
<dt>Export-Kst</dt>
<dd>Ersatz-Kostenträger für Export</dd>
<dt>Bezeichnung</dt>
<dd>Kostenträger-Bezeichnung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.kontkomb.html" title="Kontenplan">Kontenplan</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.konti.html" title="Konti">Konti</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</RouteLink></p>
</div></template>


